export default data => Math.min.apply(Math, data)
